import { InfoCircleOutlined } from '@ant-design/icons';
import { Col, Row, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { LoanApplicationDto } from 'src/generated-api-client';
import { CssColors } from 'src/styles/CssVariables';
import { Language } from 'src/types/language';
import styled from 'styled-components';

type AgentLoanApplicationInitialOfferProps = {
    application?: LoanApplicationDto;
};

export const AgentLoanApplicationInitialOffer = observer(
    ({ application }: AgentLoanApplicationInitialOfferProps) => {
        const { t, i18n } = useTranslation();

        const conditionsValue = useMemo(() => {
            if (
                application?.initialOffer?.cardArabic &&
                i18n.language === Language.ar
            ) {
                return application?.initialOffer?.cardArabic;
            }

            return application?.initialOffer?.cardEnglish;
        }, [application?.initialOffer, i18n.language]);

        return (
            <Card
                title={
                    <>
                        {t('Agent.LoanApplication.InitialOffer.Title')}
                        <StyledTooltip
                            title={t(
                                'Agent.LoanApplication.InitialOffer.Title.Tooltip',
                            )}
                        >
                            <InfoCircleOutlined />
                        </StyledTooltip>
                    </>
                }
            >
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'Agent.LoanApplication.InitialOffer.OfferName',
                            )}
                            value={application?.initialOffer?.name}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'Agent.LoanApplication.InitialOffer.Conditions',
                            )}
                            formatValue="textPreWrap"
                            value={conditionsValue}
                        />
                    </Col>
                </Row>
            </Card>
        );
    },
);

const StyledTooltip = styled(Tooltip)`
    margin-left: 6px;
    cursor: pointer;
    color: ${CssColors.gray};
`;
